import React, { FunctionComponent, useEffect, useRef, useState } from "react"
import * as THREE from "three"
import { iReduction, iExhibition, iQualityReduction } from "../../definitions"
import { LinearToneMapping, Object3D, sRGBEncoding, Vector3 } from "three"
import Stats from "../../Helpers/Stats/Stats"
import SceneLoader from "../../Loaders/SceneLoader/SceneLoader"
import { ReactComponent as Close } from "../../Components/Icons/close.svg"
import { useHistory, useRouteMatch } from "react-router-dom"
import { getMesh } from "../../Helpers/requests"
import { parseQuery } from "../../Helpers/functions"
import { unstable_batchedUpdates } from "react-dom"
import { useScene } from "../../hooks/useScene"
import { SceneLoaderUtilities } from "../../Loaders/SceneLoader/SceneLoaderUtilities"
import { isMobile } from "react-device-detect"
import ExhibitionLoader from "../../Components/Loaders/ExhibitionLoader"
import { OrbitControls } from "../../Controls/OrbitControl/OrbitControl"
import { API_URL } from "../../api/Definitions"
import { AnimationController } from "../../Controls/AnimationControllers"
import { GUI } from "dat.gui"
import { PointerRaycast } from "../../Controls/FirstPersonControls/PointerRaycat"
import Slideshow from "../../Components/Slideshow"
import Gallery from "../../Components/Gallery"
import VideoOverlay from "../../Components/VideoOverlay"
import "./ui.css"

import { InteractionPoint } from "../../Components/InteractionPoint"

const panels: {
  [index: string]: any
} = {
  environment: {
    texts: [
      "Location: Milutina Milankovica Boulevard, New Belgrade",
      "Available from Q3 2022",
    ],
  },
  exterior: {
    texts: [
      "Elegant lobby area with natural light",
      "In-house services: restaurant, caffe, ATM, corner shop",
      "24/7 security and CCTV surveillance",
    ],
  },
  garage: {
    texts: [
      "3 levels of underground car parking for 300 vehicles",
      "Elevators leading to garage level",
      "Secure bicycle storage and shower",
    ],
  },
  facade: {
    texts: [
      "Upscale façade design",
      "High quality thermal and acoustic insulation",
      "Optimized usage of natural light",
    ],
  },
  facade2: {
    texts: [
      "BMS providing energy saving",
      "Cooling and heating - all year round",
    ],
  },
  terrace: {
    texts: [
      "17.000 sqm Premium quality offices",
      "Terraces on each floor",
      "Excellent transport links",
      "Medical centre, hotel, restaurants on walking distance",
    ],
  },
  roof: {
    texts: [
      "LEED GOLD certification",
      "HVAC – 4 pipe fun coil system",
      "Diesel generator",
    ],
  },
}

enum EPointerState {
  NONE,
  DOWN,
  DRAG,
  UP,
}
let animationController: AnimationController
let controls: OrbitControls
const interactionPoints: Array<InteractionPoint> = new Array<InteractionPoint>()
let fixedCamera = false
const Exhibition: FunctionComponent = () => {
  const [isLoading, setLoading] = useState(true)
  const [isAddLoading, setAddLoading] = useState(false)

  const [showIframe, setShowIframe] = useState(false)
  const [iframeSource, setIframe] = useState("")
  const [progress, setProgress] = useState(0)
  const [exhibition, setExhibition] = useState<iExhibition>()
  const [showPanel, setShowPanel] = useState(false)
  const [staticCamera, setStaticCamera] = useState(false)
  const [showGallery, setShowGallery] = useState(false)
  const [showVideo, setShowVideo] = useState(false)
  const [panelInfo, setPanelInfo] = useState<Record<string, any> | undefined>()
  const container = useRef<HTMLDivElement>(null)
  const match = useRouteMatch<{ url: string }>()
  const history = useHistory()

  let mouse = new THREE.Vector2(0, 0)
  let downMousePosition = new THREE.Vector2(0, 0)
  let pointerState = EPointerState.NONE
  let pointerDownTime = 0
  const mouseDirection: THREE.Vector2 = new THREE.Vector2()
  let lastSavedPoint: Object3D | undefined = undefined
  const updateTime = 0
  let lastTap = 0
  let lastMousePosition = new THREE.Vector2(0, 0)
  let indexStatic = 0

  const { renderer, scene } = useScene({ container })

  let pointerRaycaster: PointerRaycast
  const startTime = new Date().getTime()

  useEffect(() => {
    const container = document.getElementById("stats")
    window.addEventListener("resize", onWindowResize)
    const stats = Stats()
    container?.appendChild(stats.dom)
    scene.background = new THREE.Color(1, 1, 1)
    const camera = new THREE.PerspectiveCamera(
      60,
      window.innerWidth / window.innerHeight,
      0.01,
      10000,
    )

    camera.layers.enable(0)
    camera.layers.disable(1)
    camera.layers.disable(2)
    camera.layers.enable(3)

    pointerRaycaster = new PointerRaycast(camera, 1, scene, renderer.domElement)

    if (!isMobile) {
      renderer.setPixelRatio(window.devicePixelRatio)
    } else {
      renderer.setPixelRatio(window.devicePixelRatio / 2)
    }
    renderer.outputEncoding = sRGBEncoding
    renderer.toneMapping = LinearToneMapping
    renderer.toneMappingExposure = 1
    renderer.setSize(window.innerWidth, window.innerHeight - 10)
    renderer.autoClear = false
    const group = new THREE.Group()
    group.scale.set(1, 1, -1)
    scene.add(group)

    const query = parseQuery(history.location.search)
    controls = new OrbitControls(camera, renderer.domElement)
    controls.enablePan = false
    controls.enableZoom = true
    controls.enableDamping = true // an animation loop is required when either damping or auto-rotation are enabled
    controls.dampingFactor = 0.1
    controls.maxPolarAngle = Math.PI / 1.9
    controls.maxDistance = 0.7
    camera.position.set(0.5, 0.5, 0.5)

    animationController = new AnimationController(scene, camera, controls)
    let depthOfFieldEffect: any
    const assets = new Map()
    let composer: any

    function hide() {
      animationController.hideRoof()
    }

    function show() {
      animationController.showRoof()
    }
    function ChangeCursor(cursorClass: string) {
      if (renderer.domElement.classList.contains(cursorClass)) {
        return
      }
      renderer.domElement.classList.remove(...renderer.domElement.classList)
      renderer.domElement.classList.add(cursorClass)
    }
    function castPoints() {
      const traced = traceInteractable()
      if (traced.traced == true) {
        if (lastSavedPoint == undefined) {
          lastSavedPoint = traced.object
        }
        ChangeCursor("cursor-pointer")
        if (lastSavedPoint != traced.object) {
          ;(lastSavedPoint?.parent as InteractionPoint).zoomPoint(false)
          lastSavedPoint = traced.object
        }
        ;(lastSavedPoint?.parent as InteractionPoint).zoomPoint(true)
      } else {
        if (lastSavedPoint != undefined) {
          ;(lastSavedPoint?.parent as InteractionPoint).zoomPoint(false)
          lastSavedPoint = undefined
        }
        ChangeCursor("cursor-default")
      }
    }
    let index = 0
    document.addEventListener("keydown", onDocumentKeyDown, false)
    function onDocumentKeyDown(event: KeyboardEvent) {
      switch (event.keyCode) {
        case 38: // up
        case 87: // w
          // controls.enabled = false
          hideInteractionPoints(false)
          hide()
          break

        case 37: // left
        case 65: // a
          index++
          if (index > 4) {
            index = 0
          }
          console.log(index)

          animationController.switchFixedCamera(index)
          document.querySelector(".floating-icons")?.classList.add("hidden")
          break

        case 40: // down
        case 83: // s
          // controls.enabled = true
          hideInteractionPoints(true)
          show()
          break

        case 39: // right
        case 68: // d
          animationController.enableMainCamera()
          document.querySelector(".floating-icons")?.classList.remove("hidden")
          break
      }
    }

    if (!isMobile) {
      window.addEventListener("pointerdown", onPointerDown, false)
      window.addEventListener("pointerup", onPointerUp, false)
      window.addEventListener("pointermove", onPointerMove, false)
    } else {
      renderer.domElement.addEventListener("touchstart", onTouchDown, false)
      renderer.domElement.addEventListener("touchend", onTouchUp, false)
      renderer.domElement.addEventListener("touchmove", onTouchMove, false)
    }

    window.addEventListener(
      "message",
      function (e) {
        if (e.data == "close") {
          setShowPanel(false)
        } else {
          infoPoint(e.data)
        }
      },
      false,
    )
    console.log(
      `${API_URL}/v1/${query.draft ? "draft" : "public"}-exhibitions/${
        match.params.url
      }`,
    )

    getMesh({
      link: `${API_URL}/v1/${query.draft ? "draft" : "public"}-exhibitions/${
        match.params.url
      }`,
      query,
    }).then(({ json, doc }) => {
      console.log(json)
      console.log(doc)
      const exhibition = doc as iExhibition
      setExhibition(exhibition)

      const sceneLoader = new SceneLoader({
        json,
        renderer: renderer,
        group,
        root: "https://content.vrallart.com",
        reduction: isMobile
          ? new iQualityReduction(iReduction.x1, 512)
          : new iQualityReduction(iReduction.x1, 2048),
        resetPosition: false,
        onProgress: (val) => {
          setProgress(val)
          if (val === 1) {
            const timeNow = new Date().getTime()

            if (timeNow - startTime < (isMobile ? 20000 : 12000)) {
              console.log(timeNow - startTime)
              setTimeout(function () {
                unstable_batchedUpdates(() => {
                  setLoading(false)
                  setAddLoading(false)
                  setProgress(0)
                })
                console.log(timeNow - startTime)
              }, (isMobile ? 20000 : 12000) - (timeNow - startTime))
            } else {
              unstable_batchedUpdates(() => {
                setLoading(false)
                setAddLoading(false)
                setProgress(0)
              })
            }
          }
        },
      })

      sceneLoader.Load().then(() => {
        createInteractionPoints()
        console.log(scene)
        animationController.cacheOfficeObjects()
        let start_object = scene.getObjectByName("camera_desktop_start")
        if (isMobile) {
          start_object = scene.getObjectByName("camera_mobile_start")
        } else {
          start_object = scene.getObjectByName("camera_desktop_start ")
        }

        console.log(start_object)

        if (start_object) {
          const pos = start_object.userData.objectData.trans
          camera.position.set(pos.position.x, pos.position.y, -pos.position.z)
        } else {
          camera.position.set(0.5, 0.5, 0.5)
        }
        const object = scene.getObjectByName("camera_target")
        if (object) {
          const pos = object.userData.objectData.trans
          controls.target = new Vector3(
            pos.position.x,
            pos.position.y,
            -pos.position.z,
          )
          animationController.cameraTarget = new Vector3(
            pos.position.x,
            pos.position.y,
            -pos.position.z,
          )
        } else {
          controls.target = new Vector3(0, 0, 0)
        }
        const nextFov = new Vector3()
        camera.getWorldPosition(nextFov)
        const next = animationController.changeCameraView(
          camera,
          nextFov,
        ) as Vector3
        camera.position.set(next.x, next.y, next.z)
        sceneLoader.ReorderObjects()
        SceneLoaderUtilities.UpdateArtifacts(exhibition, scene)
      })
    })

    //#endregion
    function onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight
      const nextFov = new Vector3()
      camera.getWorldPosition(nextFov)
      const next = animationController.changeCameraView(
        camera,
        nextFov,
      ) as Vector3
      if (next) {
        camera.position.set(next.x, next.y, next.z)
      }
      camera.fov = 60

      camera.updateProjectionMatrix()
      renderer?.setSize(window.innerWidth, window.innerHeight)
    }

    function createInteractionPoints() {
      const points = scene.children[0].children.filter((e) =>
        e.name.includes("info-point_"),
      )
      points.forEach((p) => {
        const data = p.name.split("_")[1]
        const interactionPoint = new InteractionPoint(camera, true, data)
        interactionPoint.position.set(p.position.x, p.position.y, p.position.z)
        scene.add(interactionPoint)

        interactionPoints.push(interactionPoint)
      })
    }

    function updateInteractionPoints() {
      if (interactionPoints && interactionPoints.length > 0) {
        interactionPoints.forEach((element) => {
          ;(element as InteractionPoint).update()
        })
      }
      //
    }

    function animate() {
      requestAnimationFrame(animate)
      animationController?.animate()
      if (controls.enabled === true) {
        controls.update()
        camera.updateProjectionMatrix()
      }
      renderer?.render(scene as THREE.Scene, camera)

      castPoints()
      updateInteractionPoints()
    }

    animate()
  }, [])

  function openInfo() {
    const infoPannel = document.querySelector(".info-pannel")
    const infoIcon = document.querySelector(".info-icon-wrap")
    // console.log(infoPannel)
    infoPannel?.classList.toggle("open")
  }

  function hideInteractionPoints(show: boolean) {
    if (interactionPoints && interactionPoints.length > 0) {
      interactionPoints.forEach((element) => {
        element.visible = show
      })
    }
  }

  function traceInteractable(): {
    traced: boolean
    name: string
    object: THREE.Object3D | undefined
  } {
    const interactable = pointerRaycaster.traceFromCameraByTag(
      mouse,
      "Point",
      10000,
      3,
    )

    if (interactable !== undefined) {
      //invoke interact event
      let interact = interactable.object
      if (interact.userData.colTarget != undefined) {
        interact = interact.userData.colTarget
      }
      return { traced: true, name: interact.userData.data, object: interact }
    }
    return { traced: false, name: "", object: undefined }
  }

  function onPointerDown() {
    pointerState = EPointerState.DOWN

    pointerDownTime = updateTime
    downMousePosition = mouse
  }

  function onPointerMove(event: MouseEvent) {
    mouse = new THREE.Vector2(0, 0)
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
    if (pointerState == EPointerState.DOWN) {
      if (!animationController.tweenedOut && !staticCamera) {
        hideInteractionPoints(false)
      } else {
        controls.update()
      }
    }

    const mousePos = new THREE.Vector2(event.screenX, event.screenY)
    lastMousePosition = mousePos
  }

  function onTouchMove(event: TouchEvent) {
    event.preventDefault() // prevent scrolling
    event.stopPropagation()
    console.log("MOve")

    mouse = new THREE.Vector2(0, 0)
    mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1
    mouse.y = -(event.touches[0].clientY / window.innerHeight) * 2 + 1
    const mousePos = new THREE.Vector2(
      event.changedTouches[0].screenX / 2,
      event.changedTouches[0].screenY / 2,
    )

    document.querySelector(".samllPannelsWrap")?.classList.remove("topView")
    if (!animationController.tweenedOut && !fixedCamera) {
      hideInteractionPoints(false)
    }

    pointerState = EPointerState.DRAG

    if (
      pointerState === EPointerState.DRAG &&
      mousePos !== new THREE.Vector2()
    ) {
      mouseDirection.subVectors(mousePos, lastMousePosition)
    }
    lastMousePosition = mousePos
  }

  function onPointerUp() {
    const currentTime = new Date().getTime()
    const tapLength = currentTime - lastTap

    if (!animationController.tweenedOut && !staticCamera) {
      if (fixedCamera === false) {
        hideInteractionPoints(true)
      }
    }

    if (pointerState === EPointerState.DRAG) {
      pointerState = EPointerState.UP
    } else {
      if (tapLength < 300 && tapLength > 0) {
        if (animationController.zoomedIn) {
          animationController.zoomIn(false)
        } else {
          animationController.zoomIn(true)
        }
      }
    }
    const interact = traceInteractable()
    if (interact.traced) {
      window.postMessage(interact.name, "*")
    } else {
      window.postMessage("close", "*")
    }
    lastTap = currentTime
    pointerState = EPointerState.UP
  }
  function infoPoint(point: string) {
    // console.log(panels[point])

    if (panels[point]) {
      setPanelInfo(panels[point])
      setShowPanel(true)
    }
  }
  function onTouchDown(event: TouchEvent) {
    const mousePos = new THREE.Vector2(
      event.changedTouches[0].screenX / 2,
      event.changedTouches[0].screenY / 2,
    )

    pointerState = EPointerState.DOWN
    pointerDownTime = updateTime
    downMousePosition = mouse
    lastMousePosition = mousePos
  }

  function onTouchUp(event: TouchEvent) {
    const currentTime = new Date().getTime()
    const tapLength = currentTime - lastTap
    if (animationController.tweenedOut === false) {
      if (fixedCamera === false) {
        console.log(fixedCamera, animationController.tweenedOut)
        hideInteractionPoints(true)
      }
    }
    mouse = new THREE.Vector2(0, 0)
    mouse.x = (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1
    mouse.y = -(event.changedTouches[0].clientY / window.innerHeight) * 2 + 1
    downMousePosition = mouse

    const interact = traceInteractable()
    if (interact.traced) {
      console.log(interact.name)

      window.top.postMessage(interact.name, "*")
    } else {
      window.top.postMessage("close", "*")
    }
    if (pointerState === EPointerState.DRAG) {
      pointerState = EPointerState.UP
    } else {
      if (tapLength < 300 && tapLength > 0) {
        if (animationController.zoomedIn) {
          animationController.zoomIn(false)
        } else {
          animationController.zoomIn(true)
        }
      }

      lastTap = currentTime
      pointerState = EPointerState.UP
    }
  }

  const toggleView = (layout = 0): boolean => {
    if (animationController) {
      if (animationController.finishedTransition === false) return false
      if (!animationController.tweenedOut) {
        setShowPanel(false)
        hideInteractionPoints(false)
        animationController.hideRoof(layout)
      } else {
        hideInteractionPoints(true)
        animationController.showRoof()
      }
      return true
    }
    return false
  }

  function toggleFixedCameraMode() {
    console.log(staticCamera)

    if (staticCamera) {
      fixedCamera = false
      setStaticCamera(false)
      animationController.enableMainCamera()
      hideInteractionPoints(true)
      document.querySelector(".static-icon-wrap-right")?.classList.add("hidden")
      document.querySelector(".static-icon-wrap")?.classList.add("hidden")
      document.querySelector(".d3-view")?.classList.add("hidden")
      document.querySelector(".cam-view")?.classList.remove("hidden")
      const layoutBtns = document.querySelectorAll(".main-view")
      layoutBtns.forEach((element) => {
        element.classList.remove("hidden")
      })
    } else {
      setStaticCamera(true)
      animationController.switchFixedCamera(0)
      hideInteractionPoints(false)
      fixedCamera = true
      document
        .querySelector(".static-icon-wrap-right")
        ?.classList.remove("hidden")
      document.querySelector(".d3-view")?.classList.remove("hidden")
      document.querySelector(".cam-view")?.classList.add("hidden")
      document.querySelector(".static-icon-wrap")?.classList.remove("hidden")
      const layoutBtns = document.querySelectorAll(".main-view")
      layoutBtns.forEach((element) => {
        element.classList.add("hidden")
      })
    }
  }

  function onNavStaticClick(right: boolean) {
    if (right) {
      indexStatic++
      if (indexStatic > 3) {
        indexStatic = 0
      }
    } else {
      indexStatic--
      if (indexStatic < 0) {
        indexStatic = 3
      }
    }
    animationController.switchFixedCamera(indexStatic)
  }

  function onLayoutButtonClick(layout = 0) {
    if (toggleView(layout) == false) return
    const layoutIcon = document.querySelector(".layoutBTN")
    if (layoutIcon) {
      document.querySelector(".floating-icons")?.classList.toggle("topView")
      const panel = document.querySelector(".samllPannelsWrap")
      if (panel) {
        if (animationController.tweenedOut) {
          panel.classList.contains("topView")
            ? panel.classList.remove("topView")
            : panel.classList.add("topView")
        } else {
          panel.classList.remove("topView")
        }
      }

      const layoutBtns = document.querySelectorAll(".layout-toggle")
      layoutBtns.forEach((element) => {
        element.classList.toggle("hidden")
      })

      const layoutInfos = document.querySelectorAll(".smallPannel")
      layoutInfos.forEach((element) => {
        element.classList.toggle("topView")
      })
      document.querySelector(".return-btn")?.classList.toggle("hidden")

      const galleryBtns = document.querySelectorAll(".gallery-icon")
      galleryBtns.forEach((element) => {
        element.classList.toggle("hidden")
      })
    }
  }

  const onInfoClose = () => {
    unstable_batchedUpdates(() => {
      setIframe("")
      setShowIframe(false)
    })
  }

  const closePanel = (id: string) => {
    const panel = document.querySelector("#" + id)
    panel?.classList.remove("open")
  }

  return (
    <div ref={container} className="App">
      {showIframe && (
        <div>
          <div onClick={onInfoClose} className="close">
            <Close />
          </div>
          <iframe src={iframeSource} frameBorder="0"></iframe>
        </div>
      )}
      {isLoading && (
        <div className="loaderHolder">
          <Slideshow />
          <ExhibitionLoader exhibition={exhibition} progress={progress} />
        </div>
      )}
      {isAddLoading && (
        <div className="additionalLoader">
          <div className="additionalLoaderWrap">
            <h1>LOADING HIGHER QUALITY ASSETS</h1>
            <div className="innerLoaderHolder">
              <div
                className="innerLoader"
                style={{ width: progress * 100 + "%" }}
              ></div>
            </div>
          </div>
        </div>
      )}
      {isLoading === false && (
        <>
          <div className="ui loaded">
            <div className="logo main-margin clickable">
              <img src={window.location.origin + "/gtc-x-logo.png"} alt="" />
              <div>
                <img
                  src={window.location.origin + "/gtc-x-logotip.png"}
                  alt=""
                />
              </div>
            </div>

            <div
              className="info-icon-wrap main-margin clickable"
              id="info-icon"
            >
              <img
                onClick={openInfo}
                // src={window.location.origin + "/icons/info.png"}
                src={window.location.origin + "/icons/information.png"}
                alt=""
              />
            </div>

            <div
              className="static-icon-wrap main-margin clickable hidden"
              id="info-icon"
            >
              <img
                onClick={() => onNavStaticClick(true)}
                // src={window.location.origin + "/icons/info.png"}
                src={window.location.origin + "/icons/arrow.png"}
                alt=""
              />
            </div>

            <div
              className="static-icon-wrap-right main-margin clickable hidden"
              id="info-icon"
            >
              <img
                onClick={() => onNavStaticClick(false)}
                // src={window.location.origin + "/icons/info.png"}
                src={window.location.origin + "/icons/arrow.png"}
                alt=""
              />
            </div>

            {/* Floating Icons */}
            {!showGallery && !showVideo && !staticCamera && (
              <div className="floating-icons">
                <div
                  className="layout-icon-wrap return-btn clickable hidden"
                  onClick={() => onLayoutButtonClick(0)}
                >
                  <div className="layoutBTN"></div>
                  <div className="layoutText ">3D View</div>
                </div>

                <div
                  className="layout-icon-wrap main-view layout-toggle clickable"
                  onClick={() => onLayoutButtonClick(0)}
                >
                  <div className="layoutBTN"></div>
                  <div className="layoutText floorPlan-text">Floor plan 1</div>
                  <div className="layoutText threeDeeview-text">3D View</div>
                </div>

                <div
                  className="layout-icon-wrap main-view layout-toggle clickable"
                  onClick={() => onLayoutButtonClick(1)}
                >
                  <div className="layoutBTN"></div>
                  <div className="layoutText floorPlan-text">Floor plan 2</div>
                  <div className="layoutText threeDeeview-text">3D View</div>
                </div>

                <div
                  className="layout-icon-wrap main-view gallery-icon clickable"
                  onClick={() => {
                    setShowGallery(true)
                  }}
                >
                  <div className="layoutBTN"></div>
                  <div className="layoutText">Gallery</div>
                </div>

                <div
                  className="layout-icon-wrap main-view gallery-icon clickable"
                  onClick={() => {
                    setShowVideo(true)
                  }}
                >
                  <div className="layoutBTN"></div>
                  <div className="layoutText">Video</div>
                </div>
                <div
                  className="layout-icon-wrap gallery-icon clickable"
                  onClick={() => {
                    toggleFixedCameraMode()
                  }}
                >
                  <div className="layoutBTN"></div>
                  <div className="layoutText d3-view hidden">3D VIEW</div>
                  <div className="layoutText cam-view">Camera View</div>
                </div>
              </div>
            )}
            {fixedCamera && (
              <div className="floating-icons">
                <div
                  className="layout-icon-wrap gallery-icon clickable"
                  onClick={() => {
                    toggleFixedCameraMode()
                  }}
                >
                  <div className="layoutBTN"></div>
                  <div className="layoutText d3-view">3D VIEW</div>
                  {/* <div className="layoutText cam-view">Camera View</div> */}
                </div>
              </div>
            )}

            <div id="info-pannel" className="info-pannel pannel clickable">
              <div className="closeBTN-wrap infoPannel-closeBTN">
                <div
                  className="closeBTN"
                  onClick={() => closePanel("info-pannel")}
                >
                  <img
                    src={window.location.origin + "/icons/close.png"}
                    alt=""
                  />
                </div>
              </div>

              <div className="info-container">
                <div className="info-gtc-container">
                  <img
                    src={window.location.origin + "/gtc-x-logo_i.png"}
                    alt=""
                    className="info-logo"
                  />
                  <img
                    src={window.location.origin + "/gtc-x-logotip_i.png"}
                    alt=""
                    className="info-logotip"
                  />
                  <div className="info-content">
                    <div>Milutina Milankovica 9đ</div>
                    <div>11070 New Belgrade</div>
                    <a href="tel:+381-11-313-07-51">+381 11 313 07 51</a>
                    <a
                      href="http://www.gtcserbia.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      www.gtcserbia.com
                    </a>
                  </div>
                </div>
                <div className="info-digitalmind-container">
                  {/* <div>made by</div> */}
                  <a
                    href="https://digitalmind.rs"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={
                        window.location.origin + "/digitalmind-logo-white.png"
                      }
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>

            <div
              className={`buletin-pannel pannel clickable ${
                showPanel ? " open" : ""
              }`}
              id="roof-pannel"
            >
              <Panel
                onClose={() => setShowPanel(false)}
                texts={panelInfo?.texts}
              />
            </div>

            <div className="samllPannelsWrap">
              <div className="smallPannel" id="layoutInfo-1">
                <ul>
                  <li>Innovative and flexible offices</li>
                </ul>
              </div>
              <div className="smallPannel" id="layoutInfo-2">
                <ul>
                  <li>Floor plate 2.000 sqm</li>
                </ul>
              </div>
              <div className="smallPannel" id="layoutInfo-3">
                <ul>
                  <li>Openable windows</li>
                </ul>
              </div>
              <div className="smallPannel" id="layoutInfo-4">
                <ul>
                  <li>Modern and high quality office finishing</li>
                </ul>
              </div>
              <div className="smallPannel" id="layoutInfo-5">
                <ul>
                  <li>Usage of energy-saving lighting fixtures</li>
                </ul>
              </div>
              <div className="smallPannel" id="layoutInfo-6">
                <ul>
                  <li>6 elevators</li>
                </ul>
              </div>
              <div className="smallPannel" id="layoutInfo-77">
                <ul>
                  <li>Individual access control for each tenant</li>
                </ul>
              </div>
            </div>
          </div>
          {showGallery === true && (
            <Gallery
              onShowGallery={() => {
                setShowGallery(false)
              }}
            />
          )}
          {showVideo === true && (
            <VideoOverlay
              onShowVideo={() => {
                setShowVideo(false)
              }}
              url={"https://youtu.be/-Gwsq8ZR73I"}
            />
          )}
        </>
      )}
    </div>
  )
}

interface iProps {
  onClose: () => void
  texts?: string[]
}

const Panel: FunctionComponent<iProps> = ({ onClose, texts }) => {
  return (
    <>
      <div className="closeBTN-wrap">
        <div className="closeBTN" onClick={onClose}>
          <img src={window.location.origin + "/icons/close.png"} alt="" />
        </div>
      </div>

      <ul>
        {texts &&
          texts.map((text, i) => (
            <li key={i}>
              <span>{text}</span>
            </li>
          ))}
      </ul>
    </>
  )
}

export default Exhibition
